import { IconProps } from "../../utils/global-types/global-types";

const ChevronLeftIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="m6.743 8.411 3.333-3.333a.833.833 0 0 1 1.178 1.178L8.51 9l2.744 2.744a.833.833 0 0 1-1.178 1.179L6.743 9.589a.833.833 0 0 1 0-1.178"
      ></path>
    </svg>
  );
};

export default ChevronLeftIcon;
